import { api, apiFormData } from './api';

export interface Banner {
  id?: number;
  description?: string;
  image: string;
  mobile_image?: string;
  url?: string;
  active: boolean;
  starts_at?: string;
  expires_at?: string;
  cta_text?: string;
  link_target: string;
  utm_source?: string;
  utm_campaign?: string;
  clicks_count?: number;
  type: string;
  created_at?: string;
  updated_at?: string;
  deleted_at?: string;
}

export const bannerService = {
  getBanners: async (page = 1) => {
    const response = await api.get(`/api/admin/banners?page=${page}&per_page=10`);
    return response.data;
  },

  getBannerById: async (id: number | string) => {
    const response = await api.get(`/api/admin/banners/${id}`);
    return response.data;
  },

  createBanner: async (data: Partial<Banner>) => {
    const response = await api.post('/api/admin/banners', data);
    return response.data;
  },

  updateBanner: async (id: number | string, data: Partial<Banner>) => {
    const response = await api.put(`/api/admin/banners/${id}`, data);
    return response.data;
  },

  deleteBanner: async (id: number | string) => {
    const response = await api.delete(`/api/admin/banners/${id}`);
    return response.data;
  },

  toggleBanner: async (id: number | string) => {
    const response = await api.post(`/api/admin/banners/${id}/toggle`);
    return response.data;
  },

  moveToTop: async (id: number | string) => {
    const response = await api.post(`/api/admin/banners/${id}/move-to-top`);
    return response.data;
  },

  uploadImage: async (file: File, folder = 'banners') => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('folder', folder);

    const response = await apiFormData.post('/api/admin/upload/send', formData);
    return response.data; // Should return { location: '...' }
  }
};
